import React from "react";

const Filter = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Search" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Search-Page-M" transform="translate(-320.000000, -123.000000)">
        <g id="tune_black_24dp" transform="translate(320.000000, 123.000000)">
          <polygon id="Path" points="0 0 24 0 24 24 0 24" />
          <path
            d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
            id="Shape"
            fill={color}
            fill-rule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);

Filter.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Filter;
